<nav>
  <div>
    <img src="../../../assets/img/auri_logo.png" alt="" height="60px">
    <!-- <a href="/cliente/inicio">Inicio</a>
    <a href="/cliente/paquetes">Paquetes</a>
    <a>Como funciona?</a>
    <a href="/cliente/realizar-pago">Comprobante</a> -->
  </div>
  
  <div>
    <a class="d-block btn btn-yellow" (click)="onLoginButtonClick(loginModal, profileModal)">
        {{ usuarioActual?.first_name || usuarioActual?.nombre || 'Iniciar sesion' }}
    </a>
    <button class="btn btn-danger" type="button" *ngIf="usuarioActual" (click)="logout()">Cerrar sesion</button>
  </div>
</nav>

<ng-template #loginModal>
  <div class="modal-header bg-dark">
    <h5 class="text-white mb-0">Iniciar sesion</h5>
    <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
  </div>
  <div class="modal-body">
    <p>Ingresa tus datos para continuar con tu compra.</p>
    <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
      <div class="form-group">
        <label for="login-username">Usuario o celular</label>
        <input id="login-username" type="text" class="form-control" formControlName="username">
      </div>
      <div class="form-group">
        <label for="login-password">Contrasena</label>
        <input id="login-password" type="password" class="form-control" formControlName="password">
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn" type="submit" [disabled]="loginSubmitting">
          {{ loginSubmitting ? 'Iniciando...' : 'Iniciar sesion' }}
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #profileModal>
  <div class="modal-header bg-dark">
    <h5 class="text-white mb-0">Mi cuenta</h5>
    <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
  </div>
  <div class="modal-body" *ngIf="usuarioActual">
    <p><strong>Nombre:</strong> {{ nombrePerfil }}</p>
    <p><strong>Correo:</strong> {{ usuarioActual.email || 'Sin correo registrado' }}</p>
    <p><strong>Celular:</strong> {{ usuarioActual.celular || 'Sin celular registrado' }}</p>    
    <p><strong>Grupo:</strong> {{ grupoPrecargado.nombre || 'Sin grupo registrado' }}</p>
    <div class="d-flex justify-content-end">
      <button class="btn btn-danger" type="button" (click)="logout()">Cerrar sesion</button>
    </div>
  </div>
</ng-template>

<div class="bg-yellow">
<div class="libreta">

    <div class="d-flex flex-column">
        <video *ngIf="'https://api.sandboxmb2.com/uploads/video/WhatsApp_Video_2023-08-16_at_15.31.54.mp4'"
            [src]="'https://api.sandboxmb2.com/uploads/video/WhatsApp_Video_2023-08-16_at_15.31.54.mp4'"
            frameborder="0"
            
            style="width: 90%; max-width: 600px; margin: 0 auto; min-height: 300px;">
        </video>
        <!-- autoplay="true" -->

        <div class="d-flex gap-5 align-items-center justify-content-between p-2 mt-3 flex-wrap">
            <a class="d-block btn btn-dark text-white" *ngIf="!usuarioActual" (click)="openModal(myModalUsuario)">Registro</a>
            <a class="d-block btn btn-yellow" *ngIf="!usuarioActual" (click)="onLoginButtonClick(loginModal, profileModal)">
            {{ usuarioActual?.first_name || usuarioActual?.nombre || 'Iniciar sesion' }}
            </a>
        </div>
        <a class="d-block btn btn-yellow mt-2" *ngIf="usuarioActual" href="/cliente/paquetes">
            Siguiente
        </a>
    </div>


    <ng-template #myModalUsuario let-c="close" let-d="dismiss">
        <div class="modal-header bg-dark">
            <h5 class="text-white">Agregar Datos</h5>
            <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
        </div>

        <div class="modal-body">
            <div *ngIf="usuarioActual" class="registered-alert">
                Ya estas registrado.
            </div>
            <p>Crea tu cuenta y crearemos los mejores momentos de tu graduacion</p>

            <div class="warning-text d-flex align-items-center gap-1">
                <img src="../../../assets/img/warning-logo.png" alt="" height="20px" class="d-block m-2">
                <div>
                    <p class="m-0 p-0">Revisa que tus datos sean correctos</p>
                    <p class="m-0 p-0">Tu nombre aparecera como lo hayas escrito aqui</p>                    
                </div>
            </div>

            <!-- Formulario reactivo que alimenta /api/agregarClienteGrupoV2/ -->
            <form class="mt-3" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                <div class="row">
                    <div class="form-group col-12" *ngIf="grupoPreseleccionado; else grupoSelector">
                        <label>Grupo</label>
                        <div class="grupo-precargado">
                            <p class="mb-1">
                                <strong>{{ grupoPrecargado?.nombre || ('Grupo ' + grupoPreseleccionado) }}</strong>
                            </p>
                            <p class="mb-1" *ngIf="grupoPrecargado?.carrera">
                                <span>Carrera:</span> {{ grupoPrecargado.carrera }}
                            </p>
                            <p class="mb-0" *ngIf="grupoPrecargado?.escuela">
                                <span>Escuela:</span> {{ grupoPrecargado.escuela }}
                            </p>
                            <p class="mb-0" *ngIf="loadingGrupo">Cargando informacion del grupo...</p>
                        </div>
                    </div>
                    <ng-template #grupoSelector>
                    <div class="form-group col-12">
                        <label for="grupo">Selecciona tu grupo</label>
                        <select id="grupo" class="form-control" formControlName="grupo">
                            <option value="">Selecciona una opcion</option>
                            <option *ngFor="let grupo of grupos" [value]="grupo.id">{{ grupo.nombre }} </option>
                        </select>
                    </div>
                    </ng-template>
                    <div class="form-group col-12">
                        <label for="Nombre">Nombre</label>
                        <input id="Nombre" type="text" class="form-control" formControlName="nombre">
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="ApellidoP">Apellido paterno</label>
                        <input id="ApellidoP" type="text" class="form-control" formControlName="apellidoPaterno">
                    </div>                
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="ApellidoM">Apellido materno</label>
                        <input id="ApellidoM" type="text" class="form-control" formControlName="apellidoMaterno">                  
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="celular">Celular</label>
                        <input id="celular" type="text" class="form-control" formControlName="celular">                    
                    </div>                
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="correo">Correo electronico</label>
                        <input id="correo" type="email" class="form-control" formControlName="correo">                  
                    </div>                
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="password">Contraseña</label>
                        <input id="password" type="password" class="form-control" formControlName="password">                    
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                        <label for="password-confirm">Confirmar contraseña</label>
                        <input id="password-confirm" type="password" class="form-control" formControlName="passwordConfirm">                  
                    </div>
                </div>
                
                <!-- Paso 2: mostramos el video de registro que proviene de /api/getContenido/ -->
                <div *ngIf="submitData">
                    <div>
                        <iframe src="assets/contratos/contrato_auri.pdf" style="width:100%;height:700px;"></iframe>
                    </div>
                    <div class="form-check mt-3" *ngIf="submitData">
                        <input type="checkbox" class="form-check-input" id="exampleCheck1" formControlName="acceptTerms">
                        <label class="form-check-label" for="exampleCheck1">Acepto terminos y condiciones de este contrato</label>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <button class="btn mt-4 mb-4" type="submit" [disabled]="usuarioActual || submittingForm || loadingGrupo">
                        {{ submitData ? 'Finalizar registro' : 'Siguiente' }}
                    </button>
                </div>
            </form>

        </div>

    </ng-template>

</div>
</div>
